import React from 'react';
import './CircularProgress.scss';

const CircularProgress = ({ remaining, total, tier = 'default' }) => {
  // Calculate progress percentage (filled based on USED, not remaining)
  const used = total - remaining;
  const percentage = total > 0 ? (used / total) * 100 : 0;

  // SVG circle circumference
  const circumference = 2 * Math.PI * 45; // radius = 45 in viewBox
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  // Format the display text
  let displayText = `${remaining}/${total}`;
  let badgeText = '';

  if (tier === 'limited') {
    displayText = '0/0';
    badgeText = 'Starter';
  } else if (tier === 'free') {
    badgeText = 'Starter';
  } else if (tier === 'paid') {
    badgeText = 'Pro';
  }

  return (
    <div className="counter-wrapper">
      <div className="tier-badge">{badgeText}</div>
      <div className={`circular-progress ${tier}`}>
        <div className="progress-container">
          {/* SVG Circular Progress Ring */}
          <svg viewBox="0 0 100 100" className="progress-ring">
            {/* Background circle */}
            <circle
              cx="50"
              cy="50"
              r="45"
              className="progress-background"
            />

            {/* Progress ring */}
            <circle
              cx="50"
              cy="50"
              r="45"
              className="progress-fill"
              style={{
                strokeDashoffset: strokeDashoffset,
                strokeDasharray: circumference
              }}
            />
          </svg>

          {/* Center text content */}
          <div className="progress-text">
            <div className="progress-value">{displayText}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CircularProgress;
